module.exports = __webpack_public_path__ + "media/slip_opinion/slip-opinion-sample-d0fff5b9.png";